import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface INetworkState {
  speed: number;
  latency: number | null
  speedLoading: boolean
  openMachineLimitDialog: boolean;
}

const initialState: INetworkState = {
  speed: 0,
  latency: null,
  speedLoading: false,
  openMachineLimitDialog: false,
};

export const slice = createSlice({
  name: 'speed',
  initialState,
  reducers: {
    setSpeed: (state, action: PayloadAction<number>) => {
      state.speed = action.payload;
    },
    setLatency: (state, action: PayloadAction<number | null>) => {
      state.latency = action.payload;
  
    },
    setLoaderNetwork(state, action) {
      state.speedLoading = action.payload;
    },
    openMachineLimitDialog(state, action) {
      state.openMachineLimitDialog = action.payload;
    },
  },
});

export const { setSpeed, setLatency, setLoaderNetwork } = slice.actions;

export const LimitsSliceAction = slice.actions;

//when machine goes into investigation state that time execute
export const handleMachineLimitDialog = () => async (dispatch) => {
  dispatch(slice.actions.openMachineLimitDialog(true));
};

export const reducer = slice.reducer;
export default slice;
